import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";
import CustomSelect from '../../GlobalComponents/CustomSelect'

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'

var reformatOptionRank = function (ranks) {
    return ranks.map(function(rank) {
      var newObj = {};
      newObj["label"] = rank.rank_name;
      newObj["value"] = rank.rank_uuid;

      return newObj;
    });
  };

  var reformatOptionWorkUnit = function (workunits) {
      return workunits.map(function(workunit) {
        var newObj = {};
        newObj["label"] = workunit.work_unit_name;
        newObj["value"] = workunit.work_unit_uuid;

        return newObj;
      });
    };

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            OptionRank : [],
            OptionWorkUnit : [],
        }
    }


    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        // console.log(response);
                        this.setState({
                            dataForm: {
                              uuid: response.sk_pension_uuid,
                              employee_uuid: response.sk_pension_employee_uuid,
                              sk_pension_bkn_number: response.sk_pension_bkn_number,
                              sk_pension_bkn_date: response.sk_pension_bkn_date,
                              sk_pension_number: response.sk_pension_number,
                              sk_pension_date : response.sk_pension_date,
                              sk_pension_tmt_date : response.sk_pension_tmt_date,
                              sk_pension_employee_rank_uuid : response.sk_pension_employee_rank_uuid,
                              sk_pension_year_of_services : response.sk_pension_year_of_services,
                              sk_pension_month_of_serices : response.sk_pension_month_of_serices,
                              sk_pension_employee_work_unit_uuid : response.sk_pension_employee_work_unit_uuid
                            },
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.updateBloc.fetchDetail({uuid: queryParams.get('uuid') })


        // get data rank
        this.updateBloc.rankChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            OptionRank: reformatOptionRank(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.updateBloc.fetchRank({
        })

         // get data work unit
        this.updateBloc.workUnitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            OptionWorkUnit: reformatOptionWorkUnit(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.updateBloc.fetchWorkUnit({
        })

    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="skpensiun"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Edit Data SK Pensiun</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                      {/* Masih HardCode */}
                                      <AvField
                                            name="uuid"
                                            type="hidden"
                                            id="sk_pension_uuid"
                                            value={this.state.dataForm.uuid}
                                      />
                                      <AvField
                                            name="employee_uuid"
                                            type="hidden"
                                            id="employee_uuid"
                                            value={this.state.dataForm.employee_uuid}
                                      />
                                      {/* Sampai Sini */}

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor BKN <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="sk_pension_bkn_number"
                                                    placeholder="Nomor BKN..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor BKN"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="sk_pension_bkn_number"
                                                    value={this.state.dataForm.sk_pension_bkn_number}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal BKN <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="sk_pension_bkn_date"
                                                    placeholder="Tanggal BKN..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal BKN"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="sk_pension_bkn_date"
                                                    value={this.state.dataForm.sk_pension_bkn_date}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="sk_pension_number"
                                                    placeholder="Nomor SK..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor SK"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="sk_pension_number"
                                                    value={this.state.dataForm.sk_pension_number}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="sk_pension_date"
                                                    placeholder="Tanggal SK..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal SK"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="sk_pension_date"
                                                    value={this.state.dataForm.sk_pension_date}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal TMT <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="sk_pension_tmt_date"
                                                    placeholder="Tanggal TMT..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal TMT"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="sk_pension_tmt_date"
                                                    value={this.state.dataForm.sk_pension_tmt_date}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pangkat <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect
                                                    name="sk_pension_employee_rank_uuid"
                                                    errorMessage="Pilih Rank"
                                                    options={this.state.OptionRank}
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Rank"
                                                    defaultValue={this.state.dataForm.sk_pension_employee_rank_uuid}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Masa Kerja <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <AvField
                                                    name="sk_pension_year_of_services"
                                                    placeholder="Tahun..."
                                                    type="text"
                                                    errorMessage="Masukkan Tahun"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="sk_pension_year_of_services"
                                                    value={this.state.dataForm.sk_pension_year_of_services}
                                                />
                                            </Col> Thn
                                            <Col md="2">
                                                <AvField
                                                    name="sk_pension_month_of_serices"
                                                    placeholder="Bulan..."
                                                    type="text"
                                                    errorMessage="Masukkan Bulan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="sk_pension_month_of_serices"
                                                    value={this.state.dataForm.sk_pension_month_of_serices}
                                                />
                                            </Col> Bln
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Dari Unit Kerja <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect
                                                    name="sk_pension_employee_work_unit_uuid"
                                                    errorMessage="Pilih Work Unit"
                                                    options={this.state.OptionWorkUnit}
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Work Unit"
                                                    defaultValue={this.state.dataForm.sk_pension_employee_work_unit_uuid}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                <AvCheckboxGroup name="checkboxExample" required errorMessage="Agreement harus di centang">
                                                    <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                                                </AvCheckboxGroup>

                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?skpensiun">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?skpensiun'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);